import { R } from '@core/utils/r';
import { Endpoint } from '@business/api/endpoint';
import { CompanyId } from '@business/entities/companies';
import { TMReceivedProductId, TMReceivedProductResponse, TMReceivedProductSearchParams } from '@business/entities/tm/TMReceivedProductResponse';
import { TimeMaterialId } from '@business/entities/tm';
import { ProductFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/ReceiveProductsModal/ReceiveProductsModal';

export function fetchReceivedProducts(data?: TMReceivedProductSearchParams) {
  return Endpoint.get<TMReceivedProductResponse[]>(`@gc/tm-received_product`, { params: R.objectCompact(data) });
}

export function createReceivedProduct(data: Partial<ProductFormData>) {
  return Endpoint.post<TMReceivedProductResponse>(`@gc/tm-received_product`, { data });
}

export function updateReceivedProduct(id: TMReceivedProductId, data: Partial<ProductFormData>) {
  return Endpoint.patch<TMReceivedProductResponse>(`@gc/tm-received_product/${id}`, { data });
}

export function deleteReceivedProduct(id: TMReceivedProductId) {
  return Endpoint.delete<void>(`@gc/tm-received_product/${id}`);
}

export function fetchReceivedProduct(id: TMReceivedProductId) {
  return Endpoint.get<TMReceivedProductResponse>(`@gc/tm-received_product/product/${id}`);
}
